import { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
// hooks
import useAuth from '../hooks/useAuth';

AuthNoGuestGuard.propTypes = {
  children: PropTypes.node
};

export default function AuthNoGuestGuard({ children }) {
  const { isAuthenticated, isWebVersion, role } = useAuth();
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);

  if ( isWebVersion() || isAuthenticated && role === "GUEST" ) {
    return <Navigate to="/" />;
  }

  if ( !isAuthenticated ) {
    return <Navigate to="/auth/login" />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
